<template>
<div>
 <div class="row">
        <div class="col-9">
            <div class="row">
                <div class="col-5">
                    <v-select class="form-control validate"
                        v-model="typeModel"
                        :class="[ showError ? 'invalid' : 'mb-2' ]"

                        :options="typeOptions"
                        :disabled="!canWrite || typeOptions.length === 0 || isRequired"
                        :clearable="false"


                        searchable
                        filterable
                    >
                        <div slot="no-options" />
                    </v-select>
                    <span v-if="isRequired" class="required">*</span>
                </div>
                <div class="col-7">
                    <v-select  v-if="isDropdown"
                        class="form-control validate"
                        :class="[ showError ? 'invalid' : '' ]"
                        v-model="dropdownValueModel"

                        :options="dropdownOptions"
                        :disabled="!canWrite || dropdownOptions.length === 0"
                        :clearable="false"

                        searchable
                        filterable

                        @search:blur="triggerValidation"
                    >
                        <div slot="no-options" />
                    </v-select>

                    <input v-else
                        type="text"
                        class="form-control validate"
                        :class="[ showError ? 'invalid' : '' ]"
                        v-model="valueModel"
                        :disabled="!canWrite"

                        @blur="triggerValidation"
                    />
                </div>
            </div>
        </div>
        <div class="col-3">
            <button class="btn btn-outline-danger pull-right" @click="$emit('delete', value.id)" :disabled="!canWrite || isRequired">
                <i class="fa fa-trash"></i> {{resource('Button_Remove')}}
            </button>
        </div>
    </div>
    <div class="row mb-2" v-if="showError">
        <div class="col-12">
            <error-message v-for="message in errors" :message="message" :key="message" />
        </div>
    </div>
</div>
</template>

<script>

import resources from '@core/Util/Mixins/resources';

import fieldValidation from './Mixins/custom-field-validation';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import ErrorMessage from '@core/Components/Errors/ErrorMessage';
import VSelect from 'vue-select';

export default {
    name: 'brick-custom-condition-field',
    
    mixins: [resources, fieldValidation, permissionsMixin],
    
    components: {
        VSelect,
        ErrorMessage
    },

    props: {
        /** @type { { id: String, type: String, value: String } } */
        value: {
            type: Object,
            required: true
        },

        /** @type {JourneyBuilder.CustomField[]} */
        availableTypes: {
            type: Array,
            required: true
        },

        /** @type { function(dropdownValue: JourneyBuilder.CustomFieldDropdownValue):Boolean } */
        isSelectableDropdownValue: {
            type: Function,
            required: true
        }
    },
    
    computed: {
        typeModel: {
            get() {
                return {
                    label: this.value.type,
                    value: this.value.type
                }
            },
            set(type) {
                const previousType = this.selectedType;
                const newType = this.availableTypes.find(t => t.name === type);
                
                //Attempt to preserve value for free input, when no value has been entered selected, take default
                let value = this.value.value;
                if(!value || value === previousType.defaultValue) {
                    value = newType.defaultValue;
                }
                
                //When switching to/from a dropdown, old value should never be taken into regard
                //When switching from a dropdown to free input -> dropdown id is irrelevant
                //When switching to a dropdown -> value is to be selected from a curated list
                if(newType.isDropdown || previousType.isDropdown) {
                    value = newType.defaultValue;
                }

                //Change null to undefined, our validation assumes undefined = no value selected
                value = value === null ? undefined : value;
                
                this.$emit('input', {
                    ...this.value,
                    type,
                    value
                });

                this.$v.$reset();
            }
        },
        
        dropdownValueModel: {
            get(){
                return this.dropdownOptions.find(option => option.id === this.value.value);
            },
            set(value){
                value = value ? value.id : undefined;
                
                this.$emit('input', {
                    ...this.value,
                    value 
                });
            }
        },
        
        valueModel: {
            get() {
                return this.value.value;
            },
            set(value) {
                this.$emit('input', {
                    ...this.value,
                    value
                });
            }
        },
        
        typeOptions(){
            return this.availableTypes.map(t => t.name);
        },

        dropdownOptions(){
            if(!this.selectedType.isDropdown) {
                return [];
            }
            
            const currentType = this.availableTypes.find(t => t.name === this.value.type);
            const dropdownValues = (currentType && currentType.dropdownValues) || [];
            
            return dropdownValues.filter(dropdownValue => this.isSelectableDropdownValue(dropdownValue));
        },

        /**
         * @return {JourneyBuilder.CustomField|undefined}
         */
        selectedType() {
            return this.availableTypes.find(t => t.name === this.value.type);
        },

        isRequired() {
            return this.selectedType.isRequired;
        },
        
        isDropdown(){
            return this.selectedType.isDropdown;
        },
        
        valueType() {
            return this.selectedType.valueType || 'string';
        },
    }
};
</script>

<style lang="scss" scoped>
    $padding: 2px;

    .required {
        position: absolute;
        right: 0;
        top: 0;
        font-weight: bold;
    }
    .text-danger.field-validation-error {
        padding-bottom: 5px;
    }
    .validate.invalid {
        border: 2px solid crimson !important;
        border-radius: 5px;
    }
</style>